export const CONFIGURATION_KEY = 'eppo-configuration';
export const META_KEY = 'eppo-configuration-meta';
